export default __webpack_public_path__ + "static/assets/a7fa73e1f7b8e8e6acfb9d3d28ff02ff.png";